export default __webpack_public_path__ + "static/media/logo.b2dbe0ab.png";